import React, { useState } from "react";
import {
  postCancelLeave,
  postCancelLeaveRequest,
} from "../ApiHelper/url_Helpers";
import { toasterSuccess, toasterError } from "./toaster";

const CancelLeaveModal = ({
  open,
  onClose,
  data,
  onRefresh,
  isRequest,
}) => {
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);
  const [touched, setTouched] = useState(false);

  const isReasonValid = reason.trim().length > 0;

  const handleSubmit = async () => {
    setTouched(true);

    if (!isReasonValid) return;

    try {
      setLoading(true);

      const payload = {
        cancellation_reason: reason.trim(),
      };

      let res;

      if (isRequest) {
        res = await postCancelLeaveRequest(payload, data?.id);
      } else {
        res = await postCancelLeave(payload, data?.id);
      }

      toasterSuccess(res?.message || "Successfully cancelled");

      if (onRefresh) onRefresh();

      setReason("");
      setTouched(false);
      onClose();
    } catch (err) {
      toasterError(err?.response?.data?.message || "Failed to cancel");
    } finally {
      setLoading(false);
    }
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg p-6 w-96 max-w-full">
        <h3 className="text-lg font-semibold mb-4">
          Cancel Leave {isRequest ? "Request" : ""}
        </h3>

        <p className="text-sm text-gray-600 mb-2">
          <span className="text-red-500">*</span> Please provide a reason for
          cancellation:
        </p>

        <textarea
          className={`w-full rounded-md p-2 outline-none mb-1 ${
            touched && !isReasonValid
              ? "border border-red-500 focus:ring-2 focus:ring-red-500"
              : "border border-gray-300 focus:ring-2 focus:ring-cyan-500"
          }`}
          rows={4}
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          onBlur={() => setTouched(true)}
          placeholder="Reason..."
        />

        {touched && !isReasonValid && (
          <p className="text-sm text-red-500 mb-4">
            Cancellation reason is required.
          </p>
        )}

        <div className="flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 border rounded-md text-gray-600 hover:bg-gray-50"
            disabled={loading}
          >
            Close
          </button>

          <button
            onClick={handleSubmit}
            className={`px-4 py-2 rounded-md text-white ${
              loading || !isReasonValid
                ? "bg-red-300 cursor-not-allowed"
                : "bg-red-500 hover:bg-red-600"
            }`}
            disabled={loading || !isReasonValid}
          >
            {loading ? "Submitting..." : "Submit"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CancelLeaveModal;